export const formatHTMLToFirstSentence = (html) => {
  // remove html tags from string
  const text = html.replace(/<[^>]*>?/gm, "");
  const result = text.split(".")[0];
  return result;
};
